import * as AthletesNoble from './AthletesNoble'
import * as MediaNoble from './MediaNoble'
import * as RacesNoble from './RacesNoble'
import * as ResultsNoble from './ResultsNoble'
import * as WeatherNoble from './WeatherNoble'

export const Nobles = {
  AthletesNoble,
  MediaNoble,
  RacesNoble,
  ResultsNoble,
  WeatherNoble,
}